import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class TargetController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    static $inject = [];
}

export const wtTarget: ComponentDefinition = {
    componentId: 'wtTarget',
    controller: TargetController,
    template: require('./target.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};